export const camelCaseToWords = (text: string, excludedWords?: string[]) => {
  if (!text) {
    return ''
  }

  let result = text.replace(/([A-Z]+)/g, ' $1').replace(/([A-Z][a-z])/g, ' $1')

  if (excludedWords) {
    excludedWords.forEach((w) => {
      result = result.toLowerCase().replace(w, '')
    })
  }

  const finalResult = result.toLowerCase().charAt(0).toUpperCase() + result.slice(1)

  return finalResult
}
